
import React from 'react';
import AppLoader from '@/components/common/AppLoader';
import { useTranslation } from 'react-i18next';

const AdminPageLoader: React.FC = () => {
  const { t } = useTranslation(['admin']);
  
  return (
    <AppLoader 
      fullScreen={true} 
      size="large" 
      message={t('admin:loading', 'Loading admin dashboard...')} 
    />
  );
};

export default AdminPageLoader;
